export const Icon40SeasLoader = (props) => (
    <svg
        version="1.1"
        id="L4"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        enableBackground="new 0 0 0 0"
        xmlSpace="preserve"
        {...props}
    >
        <path
            d="M60.7314 67.1489C60.7314 18.76 23.6384 33.6489 23.5709 3.87111H3.33837C10.15 22.4822 40.4988 18.76 40.4988 67.1489C40.4988 115.538 10.15 111.816 3.33837 130.427H23.5709C23.6384 100.649 60.7314 115.538 60.7314 67.1489V67.1489Z"
            fill="#0D49E1"
        >
            <animate attributeName="opacity" dur="1.0s" values="0;1;0" repeatCount="indefinite" begin="0.1" />
        </path>
        <path
            d="M101.197 67.1489C101.197 29.9267 67.4756 55.9822 64.1035 4.02H43.8709C43.8709 41.0933 80.964 22.4822 80.964 67.1489C80.964 111.816 43.8709 93.2044 43.8709 130.315H64.1035C67.4756 78.3155 101.197 104.371 101.197 67.1489Z"
            fill="#0D49E1"
        >
            <animate attributeName="opacity" dur="1.0s" values="0;1;0" repeatCount="indefinite" begin="0.2" />
        </path>
        <path
            d="M104.569 3.87111H84.336C84.336 55.9822 121.429 41.0933 121.429 67.1489C121.429 93.2044 84.336 78.3156 84.336 130.427H104.569C107.941 67.1489 141.662 85.76 141.662 67.1489C141.662 48.5378 107.941 67.1489 104.569 3.87111V3.87111Z"
            fill="#0D49E1"
        >
            <animate attributeName="opacity" dur="1.0s" values="0;1;0" repeatCount="indefinite" begin="0.3" />
        </path>
    </svg>
);
